import { ICON_NAMES } from 'foundations-assets/icons/iconNames';
import type { IconName } from 'foundations-assets/icons/icon.types';

const ICON_NAME_SET = new Set<string>(ICON_NAMES);

export const resolveAgentIconName = (
  iconName?: string
): IconName | undefined => {
  if (!iconName) {
    return undefined;
  }

  const normalized = iconName.endsWith('Icon')
    ? iconName.slice(0, -4)
    : iconName;

  if (!ICON_NAME_SET.has(normalized)) {
    return undefined;
  }

  return normalized as IconName;
};
